import type { Kontakt, Kontaktbereich, KontaktEingabe, KontaktImportErgebnis } from '@nac2s/shared'
import { kontaktImportErgebnisSchema, kontaktListeSchema, kontaktSchema } from '@nac2s/shared'
import { apiFetch } from './client.js'

/** Kontaktdatenbank (ADR-0016) — eigene und zentrale, je nach Bereich. */

export async function ladeKontakte(bereich: Kontaktbereich, suche?: string): Promise<Kontakt[]> {
  const frage = new URLSearchParams({ bereich })
  if (suche?.trim()) frage.set('suche', suche.trim())
  return kontaktListeSchema.parse(await apiFetch(`/api/kontakte?${frage}`)).kontakte
}

export async function kontaktAnlegen(
  bereich: Kontaktbereich,
  kontakt: KontaktEingabe,
): Promise<Kontakt> {
  const antwort = await apiFetch<{ kontakt: unknown }>('/api/kontakte', {
    method: 'POST',
    body: JSON.stringify({ bereich, kontakt }),
  })
  return kontaktSchema.parse(antwort.kontakt)
}

export async function kontaktAendern(
  bereich: Kontaktbereich,
  id: string,
  kontakt: KontaktEingabe,
): Promise<Kontakt> {
  const antwort = await apiFetch<{ kontakt: unknown }>(
    `/api/kontakte/${encodeURIComponent(id)}?bereich=${bereich}`,
    { method: 'PATCH', body: JSON.stringify(kontakt) },
  )
  return kontaktSchema.parse(antwort.kontakt)
}

export async function kontaktLoeschen(bereich: Kontaktbereich, id: string): Promise<void> {
  await apiFetch(`/api/kontakte/${encodeURIComponent(id)}?bereich=${bereich}`, {
    method: 'DELETE',
  })
}

export async function kontakteImportieren(
  bereich: Kontaktbereich,
  kontakte: readonly KontaktEingabe[],
): Promise<KontaktImportErgebnis> {
  return kontaktImportErgebnisSchema.parse(
    await apiFetch('/api/kontakte/import', {
      method: 'POST',
      body: JSON.stringify({ bereich, kontakte }),
    }),
  )
}
